import React from 'react'

import { useTranslation } from 'react-i18next'

interface DetailElementProps {
  label: string
  value?: JSX.Element | string | null
}
const DetailElement: React.FC<DetailElementProps> = ({ label, value }: DetailElementProps) => {
  const { t } = useTranslation()

  if (!value) return null // exclude details that are null|undefined|0|''
  return (
    <p key={label} className="text-md">
      <span className="font-medium mr-1.5">{t(`content.${label}`)}</span>
      <span>{value}</span>
    </p>
  )
}

export default DetailElement
